'use client'
import { OTPInput } from '@/components/common'
import { Box } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

type RHFOTPInputProps = {
  name: string
  label?: string
  helperText?: React.ReactNode
  onComplete?: (value: string) => void
  disabled?: boolean
  length?: number // Số lượng ô OTP (mặc định 6)
}

export function RHFOTPInput({
  name,
  label,
  helperText,
  onComplete,
  disabled = false,
  length = 6, // Mặc định 6 ô
}: RHFOTPInputProps) {
  const { control } = useFormContext()

  return (
    <Box sx={{ width: 'fit-content' }}>
      {label && <label className="mb-2 block text-[.875rem] font-medium">{label}</label>}

      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <OTPInput
            autoFocus
            length={length}
            value={field.value || ''}
            onChange={field.onChange}
            onComplete={onComplete}
            disabled={disabled}
            error={!!error}
            helperText={error?.message || (typeof helperText === 'string' ? helperText : '')}
          />
        )}
      />
    </Box>
  )
}
